import FNFTHeader from "./FNFTHeader";

const FNFTLayout = ({ children }) => {
  return (
    <div className="layout">
      <FNFTHeader />
      <main>{children}</main>
      {/* <Footer /> */}
    </div>
  );
};

export default FNFTLayout;
